/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Company_PhoneInputs */

const vi_invoice_company_phone = /** @type {(inputs: Invoice_Company_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điện thoại`)
};

/**

* @param {Invoice_Company_PhoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const invoice_company_phone = /** @type {((inputs?: Invoice_Company_PhoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Company_PhoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_invoice_company_phone(inputs)
});